<template>
  <validation-observer v-slot="{ invalid }">
    <form @submit.prevent="submitFormData">
      <validation-provider name="Name" v-slot="context" rules="required">
        <b-form-group label="Name">
          <b-form-input
            v-model="name"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            placeholder="e.g Finnmark"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <b-form-group v-if="isEditPage" label="URL">
        <b-form-input
          :value="getRegionUrl()"
          readonly
        />
      </b-form-group>

      <b-form-group label="Top Content">
        <wysiwyg-editor v-model="top_content" />
      </b-form-group>

      <b-form-group label="Bottom Content">
        <wysiwyg-editor v-model="bottom_content" />
      </b-form-group>

      <validation-provider name="Meta title" v-slot="context" rules="required">
        <b-form-group label="Meta title">
          <b-form-input
            v-model="meta_title"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            placeholder="e.g Finnmark is the best"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider name="Meta description" v-slot="context" rules="required">
        <b-form-group label="Meta description">
          <b-form-input
            v-model="meta_description"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            placeholder="e.g Finnmark is very beautiful place"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <template v-if="isEditPage">
        <hr />
        <responsive-image-picker
          :image-desktop="region.image_desktop"
          :image-mobile="region.image_mobile"
          :upload-fn="handleImageUpload"
          :delete-fn="handleImageDelete"
        />
      </template>

      <hr />
      <b-row align-h="end">
        <b-col cols="auto">
          <b-button variant="link" @click="$emit('close')">
            Close
          </b-button>

          <b-button variant="primary" :disabled="invalid" type="submit">
            {{ isEditPage ? 'Update' : 'Add' }}
          </b-button>
        </b-col>
      </b-row>
    </form>
  </validation-observer>
</template>

<script>
import { location } from '@/api'
import { getValidationState } from '../page-helpers'
import ResponsiveImagePicker from '@/components/ResponsiveImagePicker'
import WysiwygEditor from '@/components/WysiwygEditor';

export default {
  name: 'CountryRegionForm',
  components: { WysiwygEditor, ResponsiveImagePicker },
  props: { region: { type: Object }, country: { type: Object } },
  mounted() {
    if (!this.isEditPage) return

    this.name = this.region.name
    this.top_content = this.region.top_content
    this.bottom_content = this.region.bottom_content
    this.meta_title = this.region.seo?.meta_title
    this.meta_description = this.region.seo?.meta_description
  },
  data() {
    return { name: '', top_content: '', bottom_content: '', meta_title: '', meta_description: '' }
  },
  computed: {
    isEditPage() {
      return Boolean(this.region)
    },
  },
  methods: {
    getValidationState,
    async submitFormData() {
      const data = {
        name: this.name,
        top_content: this.top_content,
        bottom_content: this.bottom_content,
        seo: {
          meta_title: this.meta_title,
          meta_description: this.meta_description,
        },
      }
      await this.$store.dispatch('auth/refreshToken');

      if (!this.isEditPage) {
        await location.regions.create(this.country.id, data)
        this.$emit('created', data)
      } else {
        await location.regions.update(this.region.id, data)
        this.$emit('updated', data)
      }

      this.$emit('ok')
    },
    async handleImageUpload(image, imageType) {
      await this.$store.dispatch('auth/refreshToken');
      const { data } = await location.regions.image(this.region.id, { [imageType]: image })

      return data[imageType]
    },
    async handleImageDelete(imageType) {
      await this.$store.dispatch('auth/refreshToken');
      await location.regions.image(this.region.id, { [imageType]: null })
    },

    getRegionUrl() {
      const clientUrl = this.$store.getters['market/enabled']
        ? this.$store.getters['market/clientUrl']
        : process.env.VUE_APP_APP_URL

      return this.isEditPage ? `${clientUrl}/steder/${this.region?.slug}` : ''
    },
  },
}
</script>
